import React from "react";

const ContactUs = ({ client }) => {
  const hasContact =
    client?.contactName || client?.contactEmail || client?.contactPhone;

  if (!hasContact) {
    return <div className="gog-muted-block">No contact details available.</div>;
  }

  return (
    <div className="gog-contact-details">
      {client.contactName && (
        <div>
          <span>Name</span>
          <strong>{client.contactName}</strong>
        </div>
      )}

      {client.contactEmail && (
        <div>
          <span>Email</span>
          <a href={`mailto:${client.contactEmail}`}>{client.contactEmail}</a>
        </div>
      )}

      {client.contactPhone && (
        <div>
          <span>Phone</span>
          <a href={`tel:${client.contactPhone}`}>{client.contactPhone}</a>
        </div>
      )}
    </div>
  );
};

export default ContactUs;